import {t} from '@lingui/core/macro';

export const validateDescription = (value: string) => {
    if (!value || value.trim().length === 0) {
        return t`Описание не может быть пустым`;
    }
    if (value.trim().length > 40) {
        return t`Описание не может превышать 40 символов`;
    }
    return true;
};